import { FormControl, MenuItem, FormHelperText } from '@mui/material';
import { FC } from 'react';
import { useQuery } from 'react-query';
import { getDocumentStatuses } from '../../fetch';
import { IDropdownResponse } from '../../models';
import { SMBSelect } from '../input';

interface IDocumentStatusesDropdownProps {
  value: string | number;
  handleChange: (val: string) => void;
  isDisabled?: boolean;
  setOptions?: (val: IDropdownResponse[]) => void;
  isRequired?: boolean;
  message?: string;
  hasError?: boolean;
}

export const DocumentStatuses: FC<IDocumentStatusesDropdownProps> = ({
  isDisabled,
  isRequired,
  value,
  handleChange,
  setOptions,
  message,
  hasError
}) => {
  const { isLoading, data: documentStatuses } = useQuery<IDropdownResponse[], Error>(
    ['getDocumentStatuses'],
    () => getDocumentStatuses(),
    {
      notifyOnChangeProps: 'tracked',
      onSuccess: d => setOptions?.(d)
    }
  );
  return (
    <FormControl fullWidth variant="outlined" size="small" required={isRequired} error={hasError}>
      <SMBSelect
        disabled={isDisabled || isLoading}
        label={isLoading ? 'Loading...' : 'Document Status'}
        value={value}
        size="small"
        required={isRequired}
        onChange={({ target: { value } }) => {
          handleChange(value as string);
        }}
        handleClear={() => {
          handleChange('');
        }}
      >
        {!isLoading && documentStatuses && documentStatuses.length === 0 && (
          <MenuItem disabled>No data available</MenuItem>
        )}
        {!isLoading &&
          documentStatuses &&
          documentStatuses.map((d, index) => {
            return (
              <MenuItem key={d.value} value={d.value}>
                {d.shorthand}
              </MenuItem>
            );
          })}
      </SMBSelect>
      {message && <FormHelperText error>{message}</FormHelperText>}
    </FormControl>
  );
};
